import { Controller } from '@hotwired/stimulus'

// Closes an open <details> (e.g. the language switcher) when the user clicks
// outside of it. Native <details> only toggles via its <summary> — CSS cannot
// remove the open attribute, so a document-level click listener is required.
export default class extends Controller {
  connect () {
    this.boundCloseOnOutsideClick = this.closeOnOutsideClick.bind(this)
    document.addEventListener('click', this.boundCloseOnOutsideClick)
  }

  disconnect () {
    document.removeEventListener('click', this.boundCloseOnOutsideClick)
  }

  closeOnOutsideClick (event) {
    if (this.element.contains(event.target)) return
    this.element.open = false
  }
}
